/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import { getCustomStyles } from "Config/Config";

const AddFollowerModal = ({
  moduleName = "",
  selectedIds = [],
  afterModalClose = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
  onModalClose = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  const [followersInput, setFollowersInput] = useState("");
  const [folowersOptions, setFollowersOptions] = useState([]);

  const [followrsValue, setFollowrsValue] = useState(null);
  const [selectedFollowers, setSelectedFollowers] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  // validate =========================
  const validationHandler = () => {
    const newErrors = {};
    if (selectedFollowers.length === 0) {
      newErrors.followerWarning = t("Please select followers");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}&userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const apiData = response.data.map((item) => ({
          value: item.value,
          label: item.label,
        }));

        const userExists = apiData.some((item) => item.value === userObj.value);

        const options = userExists ? apiData : [...apiData, userObj];

        setFollowersOptions(options);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setFollowrsValue(val);
    setSelectedFollowers(val.map((item) => item.value));
  };

  //function for save tag to user
  const addRemoveFollowersHandler = async (action) => {
    if (!validationHandler()) {
      setShowAlert(true);
      setAlertMessage(`Please select follower for follower execution`);
      setMessageType("error");
      return;
    }

    if (selectedIds.length > 0) {
      try {
        let requestUrl = url.API_BASE_URL;

        // select request url based on which module this label component is working on
        switch (moduleName) {
          case "crmleadlist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_LEAD;
            break;
          case "opportunity":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_INVOICE;
            break;
          case "task":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_TASK;
            break;
          case "companylist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_COMPANY;
            break;
          case "eventlist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_EVENT;
            break;
          case "grouplist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_GROUP;
            break;
          case "projectlist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_PROJECT;
            break;
          case "challengelist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_CHALLENGE;
            break;
          case "courselist":
            requestUrl += url.API_ADD_REMOVE_FOLLOWERS_COURSE;
            break;
          default:
            alert("error in module selection. please refresh once");
        }

        setIsSaving(true);

        let responseArr = [];

        for (let selectedId of selectedIds) {
          let followerData = {
            selectedfollowerids: selectedFollowers,
          };

          let followersUrl =
            requestUrl +
            `/${selectedId}` +
            `?token=${token}` +
            `&action=${action}`;

          const response = await putData(followersUrl, followerData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(response.data);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
          setShowAlert(true);
        }

        setIsSaving(false);
        resetHandler();
        afterModalClose(responseArr);

        // close the modal
        const bootstrapModal = document.querySelector("#addFollowers");
        const myModal = bootstrap.Modal.getInstance(bootstrapModal);
        myModal.hide();
      } catch (error) {
        setShowAlert(true);
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setShowAlert(true);
      setAlertMessage(`Please select data for follower execution`);
      setMessageType("error");
    }
  };

  // Reset all the form fields and state variables to their initial values
  const resetHandler = () => {
    setFollowersInput("");
    setFollowersOptions([]);
    setFollowrsValue(null);
    setSelectedFollowers([]);
    setErrors({});
    onModalClose();
  };

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  const followersOptionsToShow =
    folowersOptions.length > 0 ? folowersOptions : [];

  return (
    <div
      className="modal fade"
      id="addFollowers"
      tabIndex="-1"
      aria-labelledby="addFollowers"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  person_add
                </span>
              </div>
              <div>
                <h3 className="fw-bold fs-4 text-white mb-0" id="addFollowers">
                  {t("Add Followers")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Choose followers to associate items with")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              {isSaving && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold mb-0">
                    {t("Adding followers to selected items")},{" "}
                    {t("please wait")}...
                  </p>
                </div>
              )}
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="selectList"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Select Users to Follow")}
                    </label>
                    <Select
                      isMulti
                      placeholder={t("Search or select users by name or email")}
                      options={followersOptionsToShow}
                      value={followrsValue}
                      onChange={(val) => followersSelectionHandler(val)}
                      onInputChange={(val) => {
                        followersInputHandler(val);
                        if (errors.followerWarning) {
                          setErrors((prev) => ({
                            ...prev,
                            followerWarning: "",
                          }));
                        }
                      }}
                      styles={getCustomStyles(errors.followerWarning)}
                    />
                    {errors.followerWarning && (
                      <div className="invalid-feedback d-block">
                        * {errors.followerWarning}
                      </div>
                    )}
                  </div>
                </div>
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={() => {
                      addRemoveFollowersHandler("1");
                    }}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    <span className="material-symbols-outlined me-1">add</span>
                    {t("Add Followers")}
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  {/* Uncomment and style if "Remove Followers" button is needed */}
                  {/* <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center gap-2 ms-2"
                    onClick={() => {
                      addRemoveFollowersHandler("0");
                    }}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    <span className="material-symbols-outlined me-1">remove</span>
                    {t("Remove Followers")}
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFollowerModal;
